import { ApiRequestStore } from '../../../common/apiRequest.store'

class CrmExpertAddStore extends ApiRequestStore {}

export const crmExpertAddStore: CrmExpertAddStore = new CrmExpertAddStore()
